<template>
    <AdminLayout>
        <section class="flex items-start px-14 space-x-9">
            <div class="w-full">
                <div class="mt-12" v-if="addHolidayDiv">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between">
                            <p class="font-semibold text-xl text-neutral-800">Add Holiday</p>
                        </div>
                        <div class=" overflow-x-auto sm:rounded-lg pt-5">
                            <form v-on:submit.prevent="submitForm" ref="form" name="form">
                                <div class="addNewBox1" >
                                    <div class="addNewSub grid grid-cols-2 gap-5" >
                                        <div class="addNewFirst adnright" >
                                            <label>Holiday Title:</label>
                                            <input class="addNewInput" type="text" v-model="formData.title" placeholder="Holiday Title">
                                            <p class="text-red-600" v-if="titleMissing">This field is required</p>
                                        </div>
                                        <div class="addNewFirst adnright" >
                                            <label>Holiday Date:</label>
                                            <input class="addNewInput" type="date" v-model="formData.date" placeholder="Date">
                                            <p class="text-red-600" v-if="dateMissing">This field is required</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="pt-4 text-right">
                                    <button type="button" class="ml-auto mr-2 btn-gray-light" @click="this.addHolidayDiv = false">
                                        <span class="pr-2">
                                            Cancel 
                                        </span>
                                    </button>
                                    <button type="submit" class=" btn-primary-light flex items-center" :disabled="buttonclick" :class="buttonclick == true ? 'opacity-50 cursor-not-allowed' : ''">
                                        <span class="pr-2">
                                            Submit 
                                        </span>
                                        <span>
                                            <span v-if="this.btnLoader" class="animate-spin h-4 w-4 inline-block border-2 border-white border-r-white/10 border-t-white/10 rounded-full"></span>
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="mt-12">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between">
                            <p class="font-semibold text-xl text-neutral-800">Holiday List</p>
                            <div class="flex items-center">                              
                                <button v-if="!addHolidayDiv" class="ml-3 btn-primary-light flex items-center"  @click="this.addHolidayDiv = true">
                                        <span class="pl-2">
                                            Add Holiday
                                        </span>
                                </button>
                            </div>
                        </div>
                        <div class=" overflow-x-auto sm:rounded-lg pt-5">
                            <table v-if="isLoading" class="w-full text-sm text-left text-neutral-500">
                                <thead class="text-xs bg-neutral-300/50 uppercase animate-pulse">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="animate-pulse">
                                    <tr class="bg-white border-b border-neutral-100" v-for="i in 5" :key="i">
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>
                                    </tr>                                   
                                </tbody>
                            </table>
                            <table v-else class="glob_table w-full text-sm text-left text-neutral-500">
                                <thead class="bg-[#ECF6FF]">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            ID
                                        </th>                                        
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                           Holiday Name
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            Date
                                        </th>                                    
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(holiday,index) in holidayList" :key="holiday.id" class="bg-white border-b">
                                        <td scope="row" class="px-6 py-4 font-medium text-neutral-700 whitespace-nowrap">
                                            #{{ index+1 }}
                                        </td>
                                        <td class="px-6 py-4">
                                            <div class="flex items-center">{{ holiday.title }}</div>
                                        </td>
                                        <td class="px-6 py-4">
                                            <div class="flex items-center">{{ formatDate(holiday.date) }}</div>
                                        </td>
                                        <td class="px-6 py-4">                                
                                            <button type="button" @click="deleteHoliday(holiday.id)" class="border rounded-3xl px-3 py-1.5 text-xs inline-block border-orange-200 bg-orange-50 text-orange-600">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                </svg>
                                            </button>   
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <RightSideBar/> -->
        </section>
    </AdminLayout>
</template>
<script>
    import AdminLayout from '../AdminDashboard/AdminLayout.vue';
    // import RightSideBar from '../../components/RightSideBar.vue';
    import axios from "axios";
    import { BASE_URL } from "../../config";
    import { createLocal } from 'the-storages';
    import { createToast } from 'mosha-vue-toastify';
    const mirror = createLocal();
    const storage = mirror._prx;
    import moment from 'moment';

    export default {
        name: 'CountryList',
        components:{
            AdminLayout,
            // RightSideBar
        },
        data() {
            return {
                formData:{company_id:localStorage.getItem('company_id'), title:'', date:'',},
                storage:storage,
                holidayList: [],
                addHolidayDiv:false,
                titleMissing: false,
                dateMissing: false,
                isLoading: false,
                buttonclick: false,
                btnLoader: false,
                globalDateFormat: "",
            }
        },
        created(){
            this.getHolidayList();
            this.globalDateFormat = localStorage.getItem("globalDateFormat");
        },
        methods:{
            async getHolidayList() {
                this.isLoading = true; // ✅ Start loader
                
                try {
                    const formData = {
                        company_id: localStorage.getItem('company_id')
                    };
                    const response = await axios.post(BASE_URL + '/get-holiday-list', formData);
                    this.holidayList = response.data.holidayList;
                    console.log("HOLIDAY LIST:: ", response.data);
                } catch (error) {
                    console.error("Error fetching holiday list:", error);
                } finally {
                    this.isLoading = false; // ✅ Stop loader
                }
            },
            async submitForm() {
                if(this.formData.title == '') {
                    this.titleMissing = true;
                    return false;
                } else {
                    this.titleMissing = false;
                }

                if(this.formData.date == '') {
                    this.dateMissing = true;
                    return false;
                } else {
                    this.dateMissing = false;
                }
                this.btnLoader = true;
                this.buttonclick = true;
                await axios.post(BASE_URL + '/add-holiday',this.formData)
                .then((response)=>{
                    //this.stateList =  response.data.statelist;
                    console.log("DEPARTMENT DATA:: ",response.data);
                    this.addHolidayDiv = false;
                    this.formData.title = '';
                    this.formData.date = '';
                    this.getHolidayList();
                    if(response.data.success === 'success'){
                        this.btnLoader = false;
                        this.buttonclick = false;
                        this.tostMessage('success', response.data.message);
                    }else{
                        this.btnLoader = false;
                        this.buttonclick = false;
                        this.tostMessage('danger', response.data.message);
                    }
                })
            },

            tostMessage(status,message){
                createToast({
                    // title: title,
                    description: message
                },
                {
                type: status,
                timeout: 2500,
                position: 'bottom-right',
                showIcon: 'true'
                })
            },

            async deleteHoliday(holidayId) {
                if (!confirm('Are you sure you want to delete this holiday?')) return;

                try {
                    const response = await axios.delete(BASE_URL + `/delete-holiday/${holidayId}`);
                    console.log(response.data);
                    // alert('Holiday deleted successfully!');
                    this.getHolidayList(); // Refresh list after deletion
                } catch (error) {
                    console.error('Error deleting holiday:', error);
                    alert('Error deleting holiday!');
                }
            },

            formatDate(date) {
                if (!date) return '';
                return moment(date).format(this.globalDateFormat || "YYYY-MM-DD");
            },
        }
    }
</script>
<style>
    .update.bg-white.border-b{
        /* border: 1px solid black; */
        border-radius: 123px !important;
        background: #eff6ff;
    }
    .green {
        color: aquamarine;
    }
    .red {
        color: rgb(253, 164, 164);
    }
    .addNewBox1 .addNewSub .adnright, .addNewBox1 {
        padding: 0px;
        margin:0px;
    }
    .addNewBox1 .addNewSub .adnright, .addNewBox1 .addNewSub .adnleft {
        flex: 1 0 50%;
    }
    .addNewBox1 .addNewSub textarea, .addNewBox1 .addNewSub select, .addNewBox1 .addNewSub input {
        border: none;
        background-color: #f5f5f5;
        padding: 12px 15px;
        display: block;
        width: 100%;
        font-size: 13px;
        color: #666;
        resize: none;
        font-weight: 500;
        border-radius: 4px;
    }
    .addNewBox1 .addNewSub label {
        font-size: 15px;
        font-weight: 500;
        color: #3c3c3c;
        margin-bottom: 2px;
    }
</style>